if (!customElements.get('miray-card-gallery')) {
customElements.define('miray-card-gallery', class extends HTMLElement {
  connectedCallback() {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.initialize(), {once:true});
    else this.initialize();
  }
  initialize() {
    if (this.ready) return;
    this.ready = true; this.position = 0;
    this.slides = Array.from(this.querySelectorAll('.miray-card-gallery__slide'));
    this.track = this.querySelector('.miray-card-gallery__track');
    this.dots = Array.from(this.querySelectorAll('.miray-card-gallery__dots span'));
    this.status = this.querySelector('[data-gallery-status]');
    if (this.slides.length < 2) return;
    this.addEventListener('click', event => {
      const control = event.target.closest('[data-gallery-step]');
      if (control) {event.preventDefault();event.stopPropagation();this.show(this.position + Number(control.dataset.galleryStep));}
      else if (this.suppressClick) {event.preventDefault();event.stopPropagation();this.suppressClick = false;}
    }, true);
    this.addEventListener('pointerdown', event => {
      if (!event.isPrimary || event.button !== 0 || event.target.closest('button')) return;
      this.suppressClick = false;
      this.start = {x:event.clientX,y:event.clientY};
    });
    this.addEventListener('pointerup', event => {
      if (!this.start) return;
      const dx = event.clientX - this.start.x, dy = event.clientY - this.start.y;
      this.start = null;
      if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        this.suppressClick = true; this.show(this.position + (dx < 0 ? 1 : -1));event.preventDefault();
      }
    });
    this.addEventListener('pointercancel', () => {this.start = null;});
    this.addEventListener('dragstart', event => event.preventDefault());
    this.addEventListener('keydown', event => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();this.show(this.position + (event.key === 'ArrowRight' ? 1 : -1), true);
    });
  }
  show(position, focus = false) {
    this.position = (position + this.slides.length) % this.slides.length;
    const active = this.slides[this.position], template = active.querySelector('template');
    if (template) {
      const fragment = template.content.cloneNode(true);
      fragment.querySelector('img')?.setAttribute('loading','eager');
      template.replaceWith(fragment);
    }
    this.slides.forEach((slide,index) => {
      const selected = index === this.position;slide.tabIndex = selected ? 0 : -1;slide.setAttribute('aria-hidden',String(!selected));this.dots[index]?.classList.toggle('is-active',selected);
    });
    this.track.style.transform = 'translateX(-' + this.position * 100 + '%)';
    this.status.textContent = (this.position + 1) + ' / ' + this.slides.length;
    if (focus) active.focus({preventScroll:true});
  }
});
}